export default __webpack_public_path__ + "static/about--hero-34e81fadc882b8416e447a66e369ae80.jpg";